import * as angular from 'angular';
import './styling.scss';
import * as template from './template.html';
import { noWrapLastTwoWords } from 'common/source/utilities/strings';
import { ModalService } from 'common/source/services/modal';
import { HippoApiService } from 'services/hippoApi';
import { CurrentUserService } from 'services/currentUser';

const module = angular.module('contact-me-card', []);

interface ContactMeCardController extends angular.IStrictController {
    icon: string;
    contactMe(): void;
    formattedDescription: string;
    description: string;
    reason: string;
    policyId: PolicyId;
    email: string;
    phoneNumber: string;
    disableContactMeButton: boolean;
}

module.component('contactMeCard', {
    template: template,
    bindings: {
        icon: '<',
        description: '<',
        reason: '<'
    },
    controller: function(
        this: ContactMeCardController,
        modalService: ModalService,
        currentUserService: CurrentUserService,
        $stateParams: PolicyStateParams
    ) {
        this.$onInit = () => {
            this.formattedDescription = noWrapLastTwoWords(this.description);
            const policyIndex = $stateParams.policyIndex;
            currentUserService.getCustomerPolicyInfoByIndex(policyIndex).then((policyInfo: CustomerPolicyInfo) => {
                this.email = policyInfo.personal_information.email;
                this.phoneNumber = policyInfo.personal_information.phone_number;
                this.policyId = policyInfo.id;
            });
        };

        this.contactMe = () => {
            modalService
                .openCloseableModal('contact-me-confirmation', {
                    email: this.email,
                    phoneNumber: this.phoneNumber,
                    policyId: this.policyId,
                    reason: this.reason
                })
                .closePromise.then((data: any) => {
                    if (data.value === 'confirmed') {
                        this.disableContactMeButton = true;
                    }
                });
        };
    }
});

export { module };
